export const routes = {
  ui: "/ui",
  signin: "/sign-in",
  dashboard: "/",
  dashboard_marketingactionplan: "/dashboard/marketingactionplan",
  dashboard_customerpersona: "/dashboard/customerpersona",
  dashboard_customersegment: "/dashboard/customersegment",
  dashboard_futurecustomerpersona:"/dashboard/futurecustomerpersona",
  forgot_password: "/forgot-password",
  change_password: "/change-password",
  profile: "/profile",
  customer: "/customer",
  customer_tab_current: "/customer?menu=customer&tab=current",
  customer_tab_touchpoint: "/customer?menu=customer&tab=touchpoint",
  customer_tab_future: "/customer?menu=customer&tab=future",
  customer_tab_stakeholder: "/customer?menu=customer&tab=stakeholder",
  customer_tab_competitor: "/customer?menu=customer&tab=competitor",
  customer_tab_area_usage: "/customer?menu=customer&tab=areaUsage",
  customer_tab_visit: "/customer?menu=customer&tab=visit",
  customer_tab_customercompetitor_domestic: "/customer?menu=customer&tab=customercompetitor_domestic",
  customer_tab_customercompetitor_international: "/customer?menu=customer&tab=customercompetitor_international",
  add_customer_current: "/customer/current/add",
  view_customer_current: "/customer/current/view",
  edit_customer_current: "/customer/current/edit",
  add_customer_future: "/customer/future/add",
  select_channel_add_customer_future: "/customer/future/add_channel",
  view_customer_future: "/customer/future/view",
  add_customer_domestic_competitor: "/customer/customercompetitor/domestic/add",
  add_customer_international_competitor: "/customer/customercompetitor/international/add",
  view_customer_domestic_competitor: "/customer/customercompetitor/domestic/view",
  view_customer_international_competitor: "/customer/customercompetitor/international/view",
  add_customer_touchpoint: "/customer/touchpoint/add",
  add_customer_touchpoint_page: "/customer/touchpoint/touchPointPage",
  view_customer_touchpoint: "/customer/touchpoint/view",
  view_customer_touchpoint_page: "/customer/touchpoint/touchPointPageView",
  add_customer_stakeholder: "/customer/stakeholder/add",
  edit_customer_stakeholder: "/customer/stakeholder/edit",
  view_customer_stakeholder: "/customer/stakeholder/view",
  add_customer_competitor: "/customer/competitor/add",
  edit_customer_competitor: "/customer/competitor/edit",
  add_customer_area_usage: "/customer/areaUsage/add",
  edit_customer_area_usage: "/customer/areaUsage/edit",
  add_customer_visit: "/customer/visit/add",
  edit_customer_visit: "/customer/visit/edit",
  user_management: "/user-management",
  add_user_role_management: "/user-management/role/add",
  view_user_role_management: "/user-management/role/view",
  edit_user_role_management: "/user-management/role/edit",
  verify: "/verify",
  import_file: "/import-file",
  import_error: "/import-error",
  progress_performance: "/progress-performance",
  progress_tab_indicator: "/progress-performance?menu=progress&tab=indicator",
  progress_tab_report: "/progress-performance?menu=progress&tab=performance",
  progress_tab_kpi: "/progress-performance?menu=progress&tab=kpi",
  add_indicator: "/progress-performance/indicator/add",
  add_report: "/progress-performance/performance/add",
  add_kpi: "/progress-performance/kpi/add",
  add_project: "/progress-performance/project/add",
  edit_indicator: "/progress-performance/indicator/edit",
  edit_report: "/progress-performance/performance/edit",
  edit_kpi: "/progress-performance/kpi/edit",
  edit_project: "/progress-performance/project/edit",
  export_file: "/export-file",
  export_error: "/export-error",
  kpi: "/kpi",
  voc_report: "/voc-report",
  voc_tab_detail :"/voc-report?menu=progress&tab=current",
  voc_tab_future_detail :"/voc-report?menu=progress&tab=future",
  org_chart :"/org-chart",
};
